import { HttpParams, HttpRequest,  HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Subject } from 'rxjs/Subject';

import { Faq } from '../models/faq.model';
import { ActivatedRoute } from '@angular/router';

import 'rxjs/Rx';

import { APP_CONFIG } from '../app.config';

@Injectable()
export class FaqService {
  faqsChanged = new Subject<Faq[]>();
  faqChanged = new Subject<Faq>();
  faqOperation = new Subject<Faq>();

  private faqs: Faq[] = [];

  constructor(@Inject(APP_CONFIG) private appConfig, private httpClient: HttpClient) {}

  setFaqs(faqs: Faq[]) {
    this.faqs = faqs;
    this.faqsChanged.next(this.faqs.slice());
  }

  getFaqs() {
    return this.faqs.slice();
  }

  getIdIndex(id: number) {
    return this.faqs.findIndex(c => c.ID === id);
  }

  httpGetFaqs(params: any = {}, columns: string = '', order: string = '') {
    let httpParams = new HttpParams();

    if ( columns ) {
      httpParams = httpParams.append('select', columns);
    }
    if ( order ) {
      httpParams = httpParams.append('order', order);
    }

    for (let p of Object.keys(params)) {
      httpParams = httpParams.append(p, params[p]);
    }

    const req = new HttpRequest(
      'GET',
      this.appConfig.API_ENDPOINT + '/faqs',
      {
        params: httpParams
      }
    );

    return this.httpClient.request(
      req
    )
    .map(
      (response: any) => {
        if (response.body) {
          if (response.body.status === 'success') {
            return response.body.data;
          }
        }

        return [];
      }
    )
    .subscribe(
      (response: Faq[]) => {
        this.setFaqs(response);
      }
    );
  }

  httpGetFaq(id: number) {

    const req = new HttpRequest(
      'GET',
      this.appConfig.API_ENDPOINT + '/faqs/' + id,
    );

    return this.httpClient.request(
      req
    )
    .map(
      (response: any) => {
        if (response.body) {
          if (response.body.status === 'success') {
            return response.body.data;
          }
        }

        return [];
      }
    )
    .subscribe(
      (response: Faq) => {
        this.faqChanged.next(response);
      }
    );
  }

  httpPostFaq(data: Faq) {
    const req = new HttpRequest(
      'POST',
      this.appConfig.API_ENDPOINT + '/faqs',
      data
    );

    return this.httpClient.request<any>(req)
    .map(
      (response: any) => {
        if (response.body) {
          if (response.body.status === 'success') {
            return response.body.data;
          }
        }

        return [];
      }
    )
    .subscribe(
      (response: any) => {
        this.faqOperation.next(response);
      }
    );
  }

  httpPutFaq(id: number, data: any) {
    const req = new HttpRequest(
      'PUT',
      this.appConfig.API_ENDPOINT + '/faqs/' + id,
      data
    );

    return this.httpClient.request<any>(req)
    .map(
      (response: any) => {
        if (response.body) {
          if (response.body.status === 'success') {
            return response.body.data;
          }
        }

        return [];
      }
    )
    .subscribe(
      (response: any) => {
        this.faqOperation.next(response);
      }
    );
  }

  httpDeleteFaq(id: number) {
    const req = new HttpRequest(
      'DELETE',
      this.appConfig.API_ENDPOINT + '/faqs/' + id
    );

    return this.httpClient.request<any>(req)
    .subscribe(
      (response: any) => {
        this.httpGetFaqs();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/faq.service.ts